import type { Money } from './types/dashboard.types';

export const formatMoney = (money?: Money) => {
    if (!money) return '0.00';
    return (money.amount / 100).toLocaleString('en-IN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
};

export const formatNumber = (num?: number) => {
    if (num === undefined || num === null) return '0';
    return num.toLocaleString('en-IN');
};
